import form from './form';
import section from './section';
import agreement from './agreement';
import contract from './contract';
import distribution from './distribution';

export default { section, form, agreement, contract, distribution };
